import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "splide-carousel"
}


export default /*@__PURE__*/_defineComponent({
  __name: 'WCWebAdsCarouselModern',
  props: {
    snap: { type: Boolean, default: true },
    isSlider: { type: Boolean, default: false }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (!_ctx.isSlider)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["wc-carousel", { 'wc-carousel--snap': _ctx.snap }])
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 2))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default")
      ]))
}
}

})